import { render, staticRenderFns } from "./dynamicBasicSetting.vue?vue&type=template&id=784243d6&scoped=true&"
import script from "./dynamicBasicSetting.vue?vue&type=script&lang=js&"
export * from "./dynamicBasicSetting.vue?vue&type=script&lang=js&"
import style0 from "./dynamicBasicSetting.vue?vue&type=style&index=0&id=784243d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784243d6",
  null
  
)

export default component.exports